import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Input from "../../../components/Form/Input";

const Transition = React.forwardRef(function Transition(props , ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalUpdate({ open, setOpen, saveInfo, data }) {
  const [values, setyvalues] = React.useState({
    id: data.id,
    name: data.name,
    email: data.email,
    password: ""
  });

  React.useEffect(() => {
    if(data){
      setyvalues({
        id: data.id,
        name: data.name,
        email: data.email,
        password: ""
      })
    }
    return () => {
    }
  }, [data])
  

  const handleCloseUpdate = () => {
    cleanValues();
    setOpen(false);
  };

  const save = () => {
    const arraySend = {
      id: values.id,
      name: values.name,
      email: values.email,
      password: values.password,
    };

    cleanValues();
    saveInfo(arraySend);
  };

  const cleanValues = () => {
    setyvalues({
      name: "",
      email: "",
      password: "",
    });
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleCloseUpdate}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{ position: "relative" }}
          style={{
            background: "#fff",
            padding: "0px !important",
          }}
        >
          <Toolbar
            style={{
              background: "#363335",
              width: "100%",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseUpdate}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Actualizar usuario
            </Typography>
            <Button autoFocus color="inherit" onClick={save}>
              Guardar
            </Button>
          </Toolbar>
          <div className="px-5 mt-3">
            <Input
              label="Nombre"
              name="name"
              value={values.name}
              onChange={(e) => {
                setyvalues({ ...values, name: e.target.value });
              }}
            />
            <Input
              label="Email"
              name="email"
              value={values.email}
              onChange={(e) => {
                setyvalues({ ...values, email: e.target.value });
              }}
            />
            <Input
              password
              label="Contraseña"
              name="password"
              value={values.password}
              onChange={(e) => {
                setyvalues({ ...values, password: e.target.value });
              }}
            />
          </div>
        </AppBar>
      </Dialog>
    </div>
  );
}
